import { getReferralsApiUrl } from '../config/api';
/**
 * Browser → BFF → server `executeWorkflow` (WORKFLOW_ACCESS_KEY stays on the server).
 */
export const bffWorkflowRunner = async (workflowId, initialData) => {
    const response = await fetch(getReferralsApiUrl('/workflows/execute'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            workflowId,
            initialData,
            operation: 'faf-execute-workflow',
        }),
    });
    const text = await response.text();
    let payload;
    try {
        payload = JSON.parse(text);
    }
    catch {
        throw new Error(`FAF workflow execute returned non-JSON (${response.status}): ${text.slice(0, 200)}`);
    }
    if (!response.ok || payload.error) {
        throw new Error(payload.error ?? `FAF workflow execute failed (${response.status})`);
    }
    return {
        result: payload.result,
        debug: payload.debug,
    };
};
